/* Shared placement pricing and cart rules for the Homebodii personaliser. */
window.HBPersonalisationFee = {
  feeType(design) {
    return (design.placementCode || design.placement_code) === 'back_embroidery' ? 'back' : 'standard';
  },

  total(designs, prices, quantity) {
    return quantity * designs.reduce((sum, design) => sum + Number(prices[this.feeType(design)]), 0);
  },

  buildItems(product, feeVariantIds, linkId, productTitle) {
    if (!Number.isSafeInteger(product.id) || !Number.isSafeInteger(product.quantity) || product.quantity < 1) {
      throw new Error('Please select a size and a quantity of at least one.');
    }
    const count = Number(product.properties._hb_personalisation_count || 1);
    if (!Number.isSafeInteger(count) || count < 1) throw new Error('Invalid personalisation count.');
    const properties = { ...product.properties, _hb_personalisation_id: linkId };
    let groups;
    // Keep the numeric signature for existing callers; the drawer supplies both fee IDs.
    if (typeof feeVariantIds === 'number') {
      groups = [{ id: feeVariantIds, count, details: {
        Text: properties['Personalisation Text'] || properties.Text,
        Font: properties.Font,
        Colour: properties['Thread Colour'] || properties.Colour,
        Position: properties.Placement || properties.Position
      } }];
    } else {
      let designs;
      try { designs = JSON.parse(properties._personalisation_designs); } catch (_) { /* Reject below. */ }
      if (!Array.isArray(designs) || designs.length !== count || designs.some(d => !d || !d.placement_code)) {
        throw new Error('Please review your personalisation before adding it.');
      }
      groups = ['standard', 'back'].flatMap(type => {
        const matching = designs.filter(design => this.feeType(design) === type);
        if (!matching.length) return [];
        return [{
          id: feeVariantIds?.[type], count: matching.length,
          details: {
            Text: matching.map(d => d.text).join(' / '),
            Font: matching.map(d => String(d.font || '').replace(/^./, c => c.toUpperCase())).join(' / '),
            Colour: matching.map(d => d.colour).join(' / '),
            Position: matching.map(d => d.placement).join(' / ')
          }
        }];
      });
    }
    const fees = groups.map(group => {
      const feeVariantId = group.id;
      if (!Number.isSafeInteger(feeVariantId) || feeVariantId <= 0) {
        throw new Error('Personalisation is temporarily unavailable. Please try again later.');
      }
      const feeQuantity = product.quantity * group.count;
      if (!Number.isSafeInteger(feeQuantity)) throw new Error('Invalid personalisation quantity.');
      return {
        id: feeVariantId,
        quantity: feeQuantity,
        parent_id: product.id,
        properties: {
          For: productTitle,
          ...group.details,
          _hb_personalisation_id: linkId,
          _hb_personalisation_fee: 'true',
          _hb_personalisation_count: String(group.count)
        }
      };
    });
    return [{ ...product, properties }, ...fees];
  },

  syncUpdates(updates, lines) {
    const parentQuantities = new Map();
    lines.filter((line) => line.linkId && !line.isFee).forEach((parent) => {
      if (Object.prototype.hasOwnProperty.call(updates, parent.key)) {
        parentQuantities.set(parent.linkId,
          (parentQuantities.get(parent.linkId) || 0) + Number(updates[parent.key]));
      }
    });
    lines.filter((line) => line.isFee).forEach((fee) => {
      if (parentQuantities.has(fee.linkId)) {
        updates[fee.key] = String(parentQuantities.get(fee.linkId) * Number(fee.count || 1));
      }
    });
    return updates;
  }
};
